import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        await googleLogin(sessionId);
        window.history.replaceState(null, "", "/");
        navigate("/");
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-[#6b6880]">
      <Loader2 size={30} className="spin text-[#5d8a52]" />
      <p className="font-medium">Signing you in…</p>
    </div>
  );
}
